exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#AddCurvePattern .v--modal-box.v--modal{min-height:400px!important;min-width:250px!important}#AddCurvePattern .v-card.v-card--flat.v-sheet.theme--light{height:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-332d8662","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/AddCurvePattern.vue
// module id = 1869
// module chunks = 0